/**
 * Generates a course URL from course data
 * Always uses course name, never falls back to numeric IDs
 */
export const getCourseUrl = (course: any): string => {
  if (!course?.name) {
    console.warn('Course missing name property:', course);
    return 'unknown-course';
  }
  
  return course.name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
};

/**
 * Generates a course URL from just the course name
 */
export const getCourseUrlFromName = (courseName: string): string => {
  if (!courseName) {
    console.warn('Empty course name provided');
    return 'unknown-course';
  }
  
  return courseName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}; 